__turbopack_context__.v({
  "additionalServiceCheckbox": "AdditionalServices-module__TAiBPW__additionalServiceCheckbox",
  "additionalServicesDe": "AdditionalServices-module__TAiBPW__additionalServicesDe",
  "additionalServicesWrapper": "AdditionalServices-module__TAiBPW__additionalServicesWrapper",
  "infoIcon": "AdditionalServices-module__TAiBPW__infoIcon",
  "infoIconNoVideo": "AdditionalServices-module__TAiBPW__infoIconNoVideo",
  "infoIconWrapper": "AdditionalServices-module__TAiBPW__infoIconWrapper",
  "modalBody": "AdditionalServices-module__TAiBPW__modalBody",
  "modalContainer": "AdditionalServices-module__TAiBPW__modalContainer",
  "monthlyRate": "AdditionalServices-module__TAiBPW__monthlyRate",
  "noInfo": "AdditionalServices-module__TAiBPW__noInfo",
  "pdflink": "AdditionalServices-module__TAiBPW__pdflink",
  "serviceContainer": "AdditionalServices-module__TAiBPW__serviceContainer",
  "servicePrice": "AdditionalServices-module__TAiBPW__servicePrice",
  "servicePriceContainer": "AdditionalServices-module__TAiBPW__servicePriceContainer",
  "videoIcon": "AdditionalServices-module__TAiBPW__videoIcon",
});
